import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';

// master_data/questions_mdata/2
export const getQuestionPaper = createAsyncThunk('get-question-paper', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Question/questionpaper_list`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getQuestionPaperDetail = createAsyncThunk('get-questions-data1', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Question/get_questionpaper/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const addQuestionPaper = createAsyncThunk('add-questionspaper', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Question/save-questionpaper`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getEachQuestionPaper = createAsyncThunk('get-question-paper-each', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/exam_management/qpdatalist/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const removeQuestionPaper = createAsyncThunk('delete-questionspaper', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.delete(`api/api/exam_management/remove-questionpaper/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/question_auto_gen_section_1/4 question_auto_gen_section_all/4
export const generateSectionA = createAsyncThunk('generate-section-paper-each', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/question_auto_gen_section_all`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// master_data/get_questions_types
export const getQuestionDetailInfo = createAsyncThunk('d-section-paper-each', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/get_questions_types`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getITQuestionDetailInfo = createAsyncThunk('itquestions-paper-each', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/get_questions_types`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// Question/save-question-template
export const saveQuestionTemplate = createAsyncThunk('save-question-template', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Question/save-question-template`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// Question/get_quesion_temp/1/2
export const getQuestionTemplate = createAsyncThunk('get-question-template', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Question/get_quesion_temp/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getQuesTemplateDetail = createAsyncThunk('get-question-template-detail', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Question/get_quesion_temp/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});